export function numberOfWords(value) {
    return value
        .replace(/^[\s,.;]+/, '')
        .replace(/[\s,.;]+$/, '')
        .split(/[\s,.;]+/).length;
}
export const API_ENDPOINT = 'http://188.166.250.39:2310';
// export const API_ENDPOINT = 'https://api.k-care.vn';
